export type TooltipPosition = 'near' | 'none';
export type Position = 'center' | 'right' | 'left' | 'none';
export type Color = 'white' | 'default' | 'none';

export interface HelpConfig {
  position: Position;
  color: Color;
  tooltipPosition: TooltipPosition;
  focus: string;
  index?: number;
  focusTooltip?: boolean;
}
